import parse from "html-react-parser";
import React from "react";

import Typography from "_components/atoms/typography";

import StepperHeader from "../stepperHeader";

import useStyles from "./styles";

const StepFour = ( { type, monetisationData, currentStep, totalSteps, stepData, toggleFeedback } ) => {
	if ( type === "live" ) return null;
	const { classes } = useStyles ( undefined, { name: "styles" } );

	const { title, subtitle, earnings, description } = stepData;
	const showHeader                                 = earnings === 0;

	return (
		<div className = { classes.stepFourWrapper }>

			{showHeader && (
				<StepperHeader
					currentStep       = { currentStep }
					isCompleted       = { true }
					isRejected        = { false }
					subTitle          = { subtitle }
					title             = { title }
					totalSteps        = { totalSteps }
				/>
			)}

			{description && (
				<Typography
					className = { type === "live" ? classes.earningDescription : "" }
					title     = { parse ( description ) }
				/>
			)}

			{( earnings !== undefined ) && (
				<Typography
					className = { classes.earningCount }
					title     = { parse ( "&#x20B9;" ) + ` ${ earnings }` }
				/>
			)}

		</div>

	);
};

export default StepFour;